import GhostPlaceholder from './GhostPlaceholder'
export type { GhostPlaceholderProps } from './GhostPlaceholder.types'
export { GhostPlaceholder }
